import "../../assets/scss/global.scss";
import logo from "../../assets/img/logo-w.png";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";

const PatientHeader = () => {
  const location = useLocation();

  const navigate = useNavigate();

  const [isSticky, setIsSticky] = useState(false);

  const [menuBar, setMenubar] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const isTokenAvailable = localStorage.getItem("accessToken");
    setIsLoggedIn(true);

    // if (isTokenAvailable) {
    //   setIsLoggedIn(true);
    // } else {
    //   setIsLoggedIn(false);
    // }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const top = window.scrollY;
      if (top > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures this effect runs once when the component mounts


  const handleLogoClick = () =>{
    navigate("/");
  }

  

  return (
    <>
      <header className={`site_header ${isSticky ? "sticky_header" : ""}`}>
        <div className="site_container">
          <div className="site_navbar">
            <div className="site_brand">
              <a style={{cursor: "pointer"}} onClick={handleLogoClick}>
                <img src={logo} alt="" />
              </a>
            </div>
            
          </div>
        </div>
      </header>
    </>
  );
};

export default PatientHeader;
